import React, { ReactElement } from 'react';
import DataTableComponent from './DataTable.component';
import { TableDefinition } from './DataTable.types';
import { getTableCellForProp } from './Helpers/cell.helpers';
import useDataTable from './Hooks/useDataTable';

export type DataTableContainerProps = {
  isLoading?: boolean;
  tableDefinition: TableDefinition;
  data: any[];
  selectedRows?: any[];
  onRowSelected?: (rows: any) => void;
  onRowClicked?: (row: any) => void;
  getExpandedRow?: (value: any) => ReactElement;
  rowsAreExpandable?: boolean;
};

export const useDataTableHook = (data: any, tableDefinition: TableDefinition) => {
  const { t, columns, rows } = useDataTable(data, tableDefinition);

  return {
    t,
    columns,
    rows,
  };
};

const DataTableContainer = ({
  isLoading,
  data,
  tableDefinition,
  onRowSelected,
  onRowClicked,
  selectedRows,
  getExpandedRow,
  rowsAreExpandable,
}: DataTableContainerProps) => {
  const { rows, columns } = useDataTableHook(data, tableDefinition);

  const handleSelect = (row: any) => {
    if (onRowSelected) {
      onRowSelected(row);
    }
  };

  const handleRowClick = (row: any) => {
    if (onRowClicked && tableDefinition.config?.useSelectableRows) {
      onRowClicked(row);
    }
  };

  return (
    <DataTableComponent
      isLoading={isLoading}
      getCellForType={getTableCellForProp}
      headers={columns}
      onRowClicked={handleRowClick}
      rows={rows}
      selectRow={handleSelect}
      selectedRows={selectedRows || []}
      useSelectableRows={!!tableDefinition.config?.useSelectableRows}
      getExpandedRow={getExpandedRow}
      rowsAreExpandable={rowsAreExpandable}
    />
  );
};

export default DataTableContainer;
